import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import SetPassword from "@/pages/SetPassword";

import EmployeeOnboarding from "@/pages/employee/Onboarding";
import EmployeeDashboard from "@/pages/employee/Dashboard";
import EmployeeDealerships from "@/pages/employee/Dealerships";
import EmployeeCustomers from "@/pages/employee/Customers";
import EmployeeUploads from "@/pages/employee/MyUploads";
import EmployeeSchedule from "@/pages/employee/Schedule";
import EmployeeBreaks from "@/pages/employee/Breaks";

import AdminDashboard from "@/pages/admin/Dashboard";
import AdminEmployees from "@/pages/admin/Employees";
import AdminDealerships from "@/pages/admin/Dealerships";
import AdminTags from "@/pages/admin/DealershipTags";
import AdminInspections from "@/pages/admin/CustomerInspections";
import AdminLogs from "@/pages/admin/Logs";
import AdminReports from "@/pages/admin/Reports";
import AdminSops from "@/pages/admin/Sops";
import AdminSchedules from "@/pages/admin/Schedules";

function RoleHome() {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/employee" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" toastOptions={{
          style: { background: "#141414", color: "#fff", border: "1px solid rgba(255,255,255,0.08)" }
        }} />
        <Routes>
          <Route path="/" element={<RoleHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/set-password/:token" element={<SetPassword />} />

          {/* Employee */}
          <Route path="/employee/onboarding" element={
            <ProtectedRoute role="employee" allowOnboarding={true}><EmployeeOnboarding /></ProtectedRoute>
          } />
          <Route path="/employee" element={
            <ProtectedRoute role="employee"><EmployeeDashboard /></ProtectedRoute>
          } />
          <Route path="/employee/dealerships" element={
            <ProtectedRoute role="employee"><EmployeeDealerships /></ProtectedRoute>
          } />
          <Route path="/employee/customers" element={
            <ProtectedRoute role="employee"><EmployeeCustomers /></ProtectedRoute>
          } />
          <Route path="/employee/uploads" element={
            <ProtectedRoute role="employee"><EmployeeUploads /></ProtectedRoute>
          } />
          <Route path="/employee/schedule" element={
            <ProtectedRoute role="employee"><EmployeeSchedule /></ProtectedRoute>
          } />
          <Route path="/employee/breaks" element={
            <ProtectedRoute role="employee"><EmployeeBreaks /></ProtectedRoute>
          } />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/employees" element={<ProtectedRoute role="admin"><AdminEmployees /></ProtectedRoute>} />
          <Route path="/admin/schedules" element={<ProtectedRoute role="admin"><AdminSchedules /></ProtectedRoute>} />
          <Route path="/admin/dealerships" element={<ProtectedRoute role="admin"><AdminDealerships /></ProtectedRoute>} />
          <Route path="/admin/dealership-tags" element={<ProtectedRoute role="admin"><AdminTags /></ProtectedRoute>} />
          <Route path="/admin/customer-inspections" element={<ProtectedRoute role="admin"><AdminInspections /></ProtectedRoute>} />
          <Route path="/admin/logs" element={<ProtectedRoute role="admin"><AdminLogs /></ProtectedRoute>} />
          <Route path="/admin/reports" element={<ProtectedRoute role="admin"><AdminReports /></ProtectedRoute>} />
          <Route path="/admin/sops" element={<ProtectedRoute role="admin"><AdminSops /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
